<template>
  <hm-col :id="$attrs['id']" cols="12">
    <hm-card-inner :full-size="true">
      <hm-col v-if="hotelSettings.details.countryCode === 'DE' && !isEmpty(disabledPaymentMethods)" cols="12">
        <span class="warning-text warning-text--full-size warning-text--no-margin col-12">Die Erfassung von Barzahlungen (nach dem 31. März 2021) ist nur noch mit aktivierter TSE möglich.</span>
      </hm-col>
    </hm-card-inner>
    <hm-card-inner v-if="isNil(payment)" :title="$t('folios.paymentEditor.card.presets')" style="padding-bottom: 0.0rem!important;">
      <hm-button :disabled="disabledPaymentMethods.includes('Cash') || disabledPaymentSources.includes('OnSite')"
                 class="btn--green btn--square btn--no-margin-top"
                 icon-left="cash"
                 cols="12 4@tablet"
                 @click="quickLink('OnSite', 'Cash')">{{ $t('folios.paymentEditor.quickLinks.cash') }}</hm-button>
      <hm-button :disabled="disabledPaymentMethods.includes('CreditCard') || disabledPaymentSources.includes('OnSite')"
                 class="btn--green btn--square btn--no-margin-top"
                 icon-left="credit-card"
                 cols="12 4@tablet"
                 @click="quickLink('OnSite', 'CreditCard')">{{ $t('folios.paymentEditor.quickLinks.creditCard') }}</hm-button>
      <hm-button class="btn--green btn--square btn--no-margin-top"
                 icon-left="wire-transfer"
                 cols="12 4@tablet"
                 @click="quickLink('NotApplicable', 'BankTransfer')">{{ $t('folios.paymentEditor.quickLinks.wireTransfer') }}</hm-button>
    </hm-card-inner>
    <hm-card-inner :title="$t('folios.paymentEditor.card.payment')">
      <hm-input-select ref="paymentSource"
                       v-model="value.paymentSource"
                       :label="$t('folios.paymentEditor.paymentSource')"
                       :disabled-options="disabledPaymentSources"
                       name="paymentSource"
                       enum-name="PaymentSource" />
      <hm-input-select ref="paymentMethod"
                       v-model="value.paymentMethod"
                       :label="$t('folios.paymentEditor.paymentMethod')"
                       name="paymentMethod">
        <option v-for="item in enums['PaymentMethod']"
                v-if="$options.PaymentMethod[item][value.paymentSource]"
                :value="item"
                :disabled="(disabledPaymentMethods).includes(item)"
                v-html="`${$t(`PaymentMethod.${item}`)}`"></option>
      </hm-input-select>
      <hm-input-select v-if="value.paymentMethod == 'CreditCard'"
                       v-model="value.creditCardType"
                       :label="$t('folios.paymentEditor.creditCardType')"
                       name="creditCardType"
                       enum-name="CreditCardType" />
      <hm-input-money v-model="value.amount"
                      :currency="hotelSettings.details.currency"
                      :required="true"
                      :label="$t('folios.paymentEditor.amount')"
                      name="amount" />
      <hm-input v-model="value.label" :label="$t('folios.paymentEditor.label')" name="label" />
      <hm-input v-if="value.paymentMethod !== 'Voucher'"
                v-model="value.transactionReference"
                :label="$t('folios.paymentEditor.transactionReference')"
                :help="$t('folios.paymentEditor.transactionReference_help')"
                name="transactionReference" />
      <hm-input v-else
                v-model="value.transactionReference"
                :label="$t('folios.transactionEditor.voucherNumber')"
                name="transactionReference" />
      <template v-if="value.paymentMethod == 'CreditCard'">
        <hm-input v-model="value.creditCardName" :label="$t('folios.paymentEditor.creditCardName')" name="creditCardName" />
        <!--
        private CreditCardType type;
    private String name; //name of the person
    @Deprecated  private String creditCardNumber;
    private YearMonth expirationDate;

        -->

      </template>
    </hm-card-inner>
  </hm-col>
</template>


<script>
/* eslint-disable no-multi-spaces,key-spacing */
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last, isNumber, toNumber } from 'lodash';
import uuid from 'uuid';
import NotificationMixin from '../../../mixins/NotificationMixin';
import FilterMixin from '../../../mixins/FilterMixin';
import HmInput from '../inputs/HmInput';
import HmInputDate from '../inputs/HmInputDate';
import HmInputMoney from '../inputs/HmInputMoney';
import HmInputToggle from '../inputs/HmInputToggle';
import HmTable from '../table/HmTable';
import HmCardInner from '../layout/HmCardInner';

export default {
  name: 'PaymentEditor',
  components: { HmCardInner, HmTable, HmInputToggle, HmInputMoney, HmInputDate, HmInput },
  mixins: [HotelmeisterMixin, NotificationMixin, FilterMixin],

  PaymentMethod: {
    Cash:                 { OnSite: true,   Online: false,  NotApplicable: false },
    Check:                { OnSite: true,   Online: false,  NotApplicable: false },
    CreditCard:           { OnSite: true,   Online: true,   NotApplicable: false },
    DebitCard:            { OnSite: true,   Online: true,   NotApplicable: false },
    DirectDebit:          { OnSite: false,  Online: false,  NotApplicable: true },
    MobilePayment:        { OnSite: true,   Online: true,   NotApplicable: false },
    BankTransfer:         { OnSite: false,  Online: false,  NotApplicable: true },
    Voucher:              { OnSite: true,   Online: true,   NotApplicable: false },
    AccountTransfer:      { OnSite: false,  Online: false,  NotApplicable: true },
    HouseAccount:         { OnSite: false,  Online: false,  NotApplicable: true },
    CustomerCard:         { OnSite: true,   Online: true,   NotApplicable: false },
    InternalConsumption:  { OnSite: false,  Online: false,  NotApplicable: true },
    Other:                { OnSite: false,  Online: true,   NotApplicable: true },
  },

  props: {
    payment: {
      type: Object,
      required: false,
      default: null,
    },
    reservation: {
      type: Object,
      required: false,
      default: null,
    },
    amount: {
      type: Number,
      required: false,
      default: 0.0,
    },
  },

  data() {
    return {
      value: {
        id: uuid.v4(),
        label: null,
        amount: this.amount,
        paymentSource: 'OnSite',
        paymentMethod: 'CreditCard',
        transactionReference: null,
        creditCardType: 'Mastercard',
      },
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    disabledPaymentSources: function () {
      switch (this.hotelSettings.details.countryCode) {
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse') || !this.$moment().isAfter(this.$moment('2021-03-31'))) {
            return [];
          } else {
            return ['OnSite'];
          }
        default: return [];
      }
    },
    disabledPaymentMethods: function () {
      switch (this.hotelSettings.details.countryCode) {
        case 'DE':
          if (this.hasLicense('EU_DE_Registrierkasse') || !this.$moment().isAfter(this.$moment('2021-03-31'))) {
            return [];
          } else {
            return ['Cash', 'Check', 'Voucher', 'CustomerCard', 'AccountTransfer'];
          }
        default: return [];
      }
    },
  },

  watch: {
    amount: function () {
      this.value.amount = this.amount;
    },
    payment: function () {
      if (isNil(this.payment)) {
        this.reInitPayment();
      } else {
        this.value = this.payment;
      }
    },
    'value.paymentSource': function (newVal) {
      if (isNil(newVal)) return;
      if (this.disabledPaymentSources.includes(newVal)) {
        newVal = 'NotApplicable';
        this.value.paymentSource = 'NotApplicable';
      }
      if (!Object.entries(this.$options.PaymentMethod).filter(it => it[1][newVal]).map(it => it[0]).includes(this.value.paymentMethod)) {
        this.value.paymentMethod = Object.entries(this.$options.PaymentMethod).filter(it => it[1][newVal]).map(it => it[0]).filter(it => !this.disabledPaymentMethods.includes(it))[0];
      }
    },
  },

  created: function () {
    if (!isNil(this.payment)) {
      this.value = this.payment;
    } else if (this.disabledPaymentMethods.includes(this.value.paymentMethod) || this.disabledPaymentSources.includes(this.value.paymentSource)) {
      this.value.paymentSource = 'NotApplicable';
      this.value.paymentMethod = 'BankTransfer';
    }
  },

  methods: {
    quickLink(paymentSource, paymentMethod) {
      this.value.paymentSource = paymentSource;
      this.value.paymentMethod = paymentMethod;
      this.$refs.paymentSource.glow();
      this.$refs.paymentMethod.glow();
    },
    reInitPayment() {
      this.value = {
        id: uuid.v4(),
        label: null,
        amount: this.amount,
        paymentSource: 'OnSite',
        paymentMethod: 'CreditCard',
        transactionReference: null,
        creditCardType: 'Mastercard',
      };
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/lib/folios/PaymentEditor.vue